module.exports = require('./helpers/bundle-url').getBundleURL('32lH7') + "logo-dark.eefe0b7f.svg";